import type * as ReactRouter from "react-router";
import { SecurityPage } from "~/app/components/landing/security-page";
import { getTranslationFn } from "~/app/i18n";

const t = getTranslationFn("en");

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Security.metaTitle") },
  { name: "description", content: t("Security.metaDescription") },
];

export default function SecurityEN() {
  return <SecurityPage locale="en" />;
}
